import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { createApp } from 'vue';
import { User } from '@/types/User';

const warningsToIgnore = [
    'Redirected when going from',
    'Avoided redundant navigation',
    'ResizeObserver loop completed with undelivered notifications',
];

function initBugsnag(user: User | null) {
    Bugsnag.start({
        apiKey: '8c02527e88cf06115a413ca16a3c45bf',
        plugins: [new BugsnagPluginVue()],
        onError(event) {
            if (user) {
                event.setUser(`${user.id}`);
            }
            if ('originalError' in event && 'isAxiosError' in event.originalError && event.originalError.isAxiosError) {
                return false;
            }
            if ('originalError' in event && 'message' in event.originalError && warningsToIgnore.some(item => event.originalError.message.includes(item))) {
                return false;
            }
            return true;
        },
    });
    const bugsnagVue = Bugsnag.getPlugin('vue');
    if (bugsnagVue) {
        // For Vue 3, we need to pass the Vue app instance
        const app = createApp({});
        bugsnagVue.installVueErrorHandler(app);
    }
}

export {
    initBugsnag,
};
